import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import DatePicker, { registerLocale } from "react-datepicker";
import ResultModal from "../Common/ResultModal";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import Tooltip from "../Common/Tooltip";
import NumberFormat from "react-number-format";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import { posServices, globalServices, tenantService } from "../../Services";
import { validationService } from "../../Services/validation.service";
import {
  numbersOnly,
  posTag,
  lettersAndNumbers,
  ictNumber,
  phoneNumber,
  numbersAndComma,
} from "../../Config/Regex";
import Select from "react-select";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { roles } from "../../Config/Roles";
registerLocale("hr", hr);
registerLocale("en", en);

const EditPOS = ({ match }) => {
  const history = useHistory();
  const { userId, roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [backUrl, setBackUrl] = useState();
  const { locName, locTenant, locStore, selectedLanguageId, locPos } =
    useContext(GlobalContext);

  const { master, admin, support, owner } = roles;

  const [tenants, setTenants] = React.useState();
  const [stores, setStores] = React.useState();
  const [pos, setPos] = useState();
  const [deposit, setDeposit] = useState();
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const selectedPosId = match.params.posId;
  const { register, handleSubmit, errors, control, formState, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { pos },
  });

  const watchedPaymentAppId = watch("paymentAppId");
  const watchedPosTypeId = watch("posTypeId");
  const isSoftPos = Number(watchedPosTypeId || pos?.posTypeId) === 2;

  useEffect(() => {
    if (![master, admin, support, owner].includes(Number(roleId)))
      history.push("/error-page/401");
    switch (locName) {
      case "tenants":
        setBackUrl(`/${locName}/${locTenant}`);
        break;
      case "stores":
        setBackUrl(`/${locName}/${locStore}`);
        break;
      case "pos":
        setBackUrl(`/${locName}${locPos == 0 ? "" : "/" + locPos}`);
        break;
      default:
        setBackUrl(`/${locName}`);
    }

    if (selectedPosId) {
      posServices.getById(selectedPosId).then((data) => {
        setPos({
          tenantId: data.data.tenantId,
          storeId: data.data.storeId,
          tag: data.data.tag,
          inventoryNumber: data.data.inventoryNumber,
          description: data.data.description,
          documentNumber: data.data.documentNumber,
          deposit: data.data.deposit,
          workingMode: data.data.workingMode,
          posSerialNumber: data.data.posserialNumber,
          subscriptionValidFrom: data.data.subscriptionValidFrom,
          //subscriptionValidTo: data.data.subscriptionValidTo,
          tid: data.data.tid,
          closeArticleSearch: data.data.closeArticleSearch,
          multiDraft: data.data.multiDraft,
          cashDefault: data.data.cashDefault,
          msisdn: data.data.msisdn,
          modeId: data.data.modeId,
          paymentAppId: data.data.paymentAppId,
          posTypeId: data.data.posTypeId,
          terminalName: data.data.terminalName,
          manufacturer: data.data.manufacturer,
          operationSystem:data.data.operationSystem,
          model:data.data.model
          // msisdn: data.data.msisdn.substr(6),
          // msisdnPrefix: data.data.msisdn.substr(4, 2),
          // msisdnCountry: data.data.msisdn.substr(0, 4),
        });
        setDeposit(data.data.deposit);
        globalServices
          .getTenants(
            Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
            "",
            data.data.tenantId
          )
          .then((res) => {
            setTenants(res.data);
          });
        setIsLoading(false);
      });
    } else {
      setPos({
        tenantId: locTenant || 0,
        storeId: locStore || 0,
        tag: "",
        description: "",
        documentNumber: "",
        deposit: "",
        workingMode: false,
        posSerialNumber: "",
        subscriptionValidFrom: null,
        //subscriptionValidTo: null,
        closeArticleSearch: false,
        multiDraft: false,
        cashDefault: false,
        tid: "",
        msisdn: "",
        msisdnPrefix: "",
        msisdnCountry: "",
        paymentAppId: "",
        posTypeId: "",
        terminalName: "",
        manufacturer:"",
        model:"",
        operationSystem:""
      });

      if (locTenant && locTenant != "0") {
        tenantService
          .getTenantSetting(locTenant)
          .then((res) => {
            if (res) {
              setPos((prevState) => ({
                ...prevState,
                closeArticleSearch: res.data.closeArticleSearch,
                multiDraft: res.data.multiDraft,
                cashDefault: res.data.cashDefault,
              }));
            }
          })
          .catch((err) => console.log("err", err));
      }

      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (pos && pos.tenantId != "0") {
      globalServices.getStoresByTenantId(pos.tenantId).then((res) => {
        setStores(res.data);
      });
    }
  }, [pos]);

  // stores - kad se stores učita znamo da je forma spremna
  useEffect(() => {
    if (stores) {
      setIsLoading(false);
    }
  }, [stores]);

  const onSubmit = (data) => {
    if (selectedPosId) {
      posServices
        .update({
          posId: selectedPosId,
          tag: data.tag,
          description: data.description,
          deposit: parseFloat(convertToDecimalString(data.deposit)),
          posserialNumber: !isSoftPos ? data.posSerialNumber:"",
          inventoryNumber: !isSoftPos ? data.inventoryNumber:"",
          subscriptionValidFrom: data.subscriptionValidFrom,
          //subscriptionValidTo: data.subscriptionValidTo,
          tid: data.tid,
          msisdn: !isSoftPos ? data.msisdn:"",
          //msisdn: data.msisdnCountry + data.msisdnPrefix + data.msisdn,
          closeArticleSearch: data.closeArticleSearch,
          multiDraft: data.multiDraft,
          cashDefault: data.cashDefault,
          workingMode: data.workingMode,
          modeId: data.modeId,
          paymentAppId: data.paymentAppId ? Number(data.paymentAppId) : null,
          posTypeId: data.posTypeId ? Number(data.posTypeId) : null,
          terminalName: Number(data.paymentAppId) === 2 ? data.terminalName : null,
          manufacturer: isSoftPos ? data.manufacturer : null,
          model: isSoftPos ? data.model : null,
          operationSystem: isSoftPos ? data.operationSystem : null,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditPOS-Update-SuccessModal-Title"),
                text: translator("EditPOS-Update-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditPOS-Update-UnsuccessModal-Title"),
                text: translator("EditPOS-Update-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditPOS-Update-UnsuccessModal-Title"),
            text: translator("EditPOS-Update-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    } else {
      posServices
        .create({
          tenantId: data.tenantId.value && parseInt(data.tenantId.id),
          storeId: data.storeId.value && parseInt(data.storeId.id),
          tag: data.tag,
          description: data.description,
          workingMode: data.workingMode,
          documentNumber: data.documentNumber && Number(data.documentNumber),
          deposit: deposit && parseFloat(convertToDecimalString(deposit)),
          posserialNumber: data.posSerialNumber,
          inventoryNumber: data.inventoryNumber,
          subscriptionValidFrom: data.subscriptionValidFrom,
          subscriptionValidTo: data.subscriptionValidTo,
          closeArticleSearch: data.closeArticleSearch,
          multiDraft: data.multiDraft,
          cashDefault: data.cashDefault,
          tid: data.tid,
          msisdn: data.msisdnCountry + data.msisdnPrefix + data.msisdn,
          modeId: data.modeId,
          paymentAppId: data.paymentAppId ? Number(data.paymentAppId) : null,
          posTypeId: data.posTypeId ? Number(data.posTypeId) : null,
          terminalName: Number(data.paymentAppId) === 2 ? data.terminalName : null,
          manufacturer: isSoftPos ? data.manufacturer : null,
          model: isSoftPos ? data.model : null,
          operationSystem: isSoftPos ? data.operationSystem : null,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditPOS-Add-SuccessModal-Title"),
                text: translator("EditPOS-Add-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditPOS-Add-UnsuccessModal-Title"),
                text: translator("EditPOS-Add-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditPOS-Add-UnsuccessModal-Title"),
            text: translator("EditPOS-Add-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const goBack = () => {
    history.push(backUrl);
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap
      title={translator("EditPOS-Title")}
      subtitle={
        selectedPosId
          ? translator("POS-EditPOS-SubTitle")
          : translator("POS-CreatePOS-SubTitle")
      }
      backUrl={backUrl}
    >
      {isLoading && <SpinnerLoading />}
      {!isLoading && pos && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("POS-New_EditPOS-BasicInformation")}
              </legend>

              <div className="form-group">
                <label htmlFor="ddlStore">{translator("EditPOS-Tenant")}</label>{" "}
                <Tooltip text={translator("POS-Tenant-Msg")} />
                {tenants && (
                  <Controller
                    isDisabled={true}
                    as={Select}
                    control={control}
                    name="tenantId"
                    placeholder={translator("Select-Tenant")}
                    rules={{ required: true }}
                    onChange={function (event) {
                      setPos({ ...pos, tenantId: event[0].id });
                      return event[0];
                    }}
                    options={
                      tenants &&
                      tenants.map((e) => ({
                        id: e.id,
                        label: e.name,
                        value: e.name,
                      }))
                    }
                    defaultValue={{
                      label:
                        tenants.length && pos.tenantId != 0
                          ? tenants.filter((x) => x.id == pos.tenantId)[0].name
                          : "",
                      value: tenants.length != 0 ? pos.tenantId : "",
                    }}
                  />
                )}
              </div>

              {errors.tenantId && errors.tenantId.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}

              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("POS-New_EditPOS-Store")}
                </label>{" "}
                <Tooltip text={translator("POS-Store-Msg")} />
                {stores ? (
                  <Controller
                    as={Select}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.name,
                      }))
                    }
                    name="storeId"
                    defaultValue={{
                      label:
                        stores.length != 0 && pos.storeId != 0
                          ? stores.filter((x) => x.id == pos.storeId)[0].name
                          : "",
                      value: stores.length != 0 ? pos.storeId : null,
                    }}
                    rules={{ required: true }}
                    control={control}
                    isDisabled={selectedPosId}
                    onChange={(event) => event[0]}
                  />
                ) : (
                  <Select placeholder="" isDisabled={true} />
                )}
                {errors.storeId && errors.storeId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group">
                <label>TID</label> <Tooltip text={translator("POS-TID-Msg")} />
                <input
                  type="number"
                  className="form-control"
                  ref={register({
                    required: false,
                    min: 12700000,
                    max: 12709999,
                    validate: function (value) {
                      if (value != "") {
                        return validationService.validateTid(
                          document.getElementsByName("tid")[0].value,
                          selectedPosId
                        );
                      }
                      return true;
                    },
                  })}
                  name="tid"
                  defaultValue={pos.tid}
                />
                {/* {errors.tid && errors.tid.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )} */}
                {errors.tid &&
                  (errors.tid.type === "min" || errors.tid.type === "max") && (
                    <p className="text-danger">
                      {translator("TIDLength-ValidationMsg")}
                    </p>
                  )}
                {errors.tid && errors.tid.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-TidInUse")}
                  </p>
                )}
              </div>
              {!isSoftPos && (
                <>
                  <div className="form-group">
                    <label>{translator("ICT-number")}</label>{" "}
                    <Tooltip text={translator("POS-ICTNum-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: true,
                        pattern: ictNumber,
                        maxLength: 25,
                        validate: () =>
                          validationService.validatePosInventoryNumber(
                            document.getElementsByName("inventoryNumber")[0].value,
                            selectedPosId
                          ),
                      })}
                      name="inventoryNumber"
                      defaultValue={pos.inventoryNumber}
                    />
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "pattern" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-LettersAndNumbers")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength25")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "validate" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-ICTinUse")}
                        </p>
                      )}
                  </div>

                  <div className="form-group">
                    <label>{translator("POS-New_EditPOS-POSSerialNumber")}</label>{" "}
                    <Tooltip text={translator("POS-SerialNumber-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: true,
                        pattern: numbersOnly,
                        maxLength: 50,
                        validate: () =>
                          validationService.validatePosSerialNumber(
                            document.getElementsByName("posSerialNumber")[0].value,
                            selectedPosId
                          ),
                      })}
                      name="posSerialNumber"
                      defaultValue={pos.posSerialNumber}
                    />
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "pattern" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-NumbersOnly")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength50")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "validate" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-SerialNumberInUse")}
                        </p>
                      )}
                  </div>

                  <div className="form-group">
                    <label>{translator("POSdevice-MSISDN")}</label>{" "}
                    <Tooltip text={translator("POS-MSISDN-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: true,
                        maxLength: 50,
                        pattern: phoneNumber,
                      })}
                      name="msisdn"
                      defaultValue={pos.msisdn}
                    />
                    {errors.msisdn && (
                      <>
                        {errors.msisdn.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                        {errors.msisdn.type === "maxLength" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-MaxLength50")}
                          </p>
                        )}
                        {errors.msisdn.type === "pattern" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-NumbersOnlyAndPlus")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}

              {isSoftPos && (
                <>
                  <div className="form-group">
                    <label>Manufacturer</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="manufacturer"
                      defaultValue={pos.manufacturer || ""}
                      disabled
                    />
                  </div>

                  <div className="form-group">
                    <label>Operation System</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="operationSystem"
                      defaultValue={pos.operationSystem || ""}
                      disabled
                    />
                  </div>

                  <div className="form-group">
                    <label>Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="model"
                      defaultValue={pos.model || ""}
                      disabled
                    />
                  </div>
                </>
              )}

              {/* <div className="form-group">
                <label>{translator("POSdevice-MSISDN")}</label>{" "}
                <Tooltip text={translator("POS-MSISDN-Msg")} />
                <div className="row">
                  <div className="col-xs-12 col-sm-6 col-xl-3 pr-1 d-none d-sm-block">
                    <input
                      type="text"
                      className="form-control"
                      name="msisdnCountry"
                      defaultValue="+385"
                      disabled
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-xl-3 d-sm-none">
                    <input
                      type="text"
                      className="form-control"
                      name="msisdnCountry"
                      ref={register}
                      defaultValue="+385"
                      disabled
                    />
                  </div>
                  {window.innerWidth >= 1200 ? (
                    <div className="col-xs-12 col-sm-6 col-xl-4 pl-0 pr-0 d-none d-xl-block">
                      <select
                        name="msisdnPrefix"
                        ref={register({
                          validate: (value) => value !== "-1",
                        })}
                        className="form-control"
                        defaultValue={pos.msisdnPrefix}
                      >
                        <option value="98">(0)98</option>
                        <option value="99">(0)99</option>
                      </select>
                    </div>
                  ) : (
                    <div className="col-xs-12 col-sm-6 col-xl-4 d-sm-none mt-1">
                      <select
                        name="msisdnPrefix"
                        ref={register({
                          validate: (value) => value !== "-1",
                        })}
                        className="form-control"
                        defaultValue={pos.msisdnPrefix}
                      >
                        <option value="98">(0)98</option>
                        <option value="99">(0)99</option>
                      </select>
                    </div>
                  )}
                  {window.innerWidth >= 1200 ? (
                    <div className="col-xs-12 col-xl-5 pl-1 d-none d-xl-block">
                      <input
                        type="number"
                        className="form-control"
                        ref={register({
                          required: true,
                          pattern: numbersOnly,
                          max: 99999999,
                        })}
                        name="msisdn"
                        defaultValue={pos.msisdn}
                      />
                    </div>
                  ) : (
                    <div className="col-xs-12 col-xl-5 mt-1 d-xl-none">
                      <input
                        type="number"
                        className="form-control"
                        ref={register({
                          required: true,
                          pattern: numbersOnly,
                          maxLength: 8,
                        })}
                        name="msisdn"
                        defaultValue={pos.msisdn}
                      />
                    </div>
                  )}
                </div>
                {errors.msisdn && (
                  <>
                    {errors.msisdn.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                    {errors.msisdn.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumbersOnly")}
                      </p>
                    )}
                    {errors.msisdn.type === "max" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength8")}
                      </p>
                    )}
                  </>
                )}
              </div> */}
            </fieldset>
          </div>

          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditPOS-MoreDetails")}
              </legend>

              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Deposit")}</label>{" "}
                <Tooltip text={translator("POS-Deposit-Msg")} />
                <Controller
                  name="deposit"
                  control={control}
                  rules={{ maxLength: 9 }}
                  as={
                    <NumberFormat
                      thousandSeparator={" "}
                      decimalSeparator={","}
                      fixedDecimalScale={true}
                      decimalScale={2}
                      placeholder={"0,00"}
                      inputMode="numeric"
                      className="form-control"
                      allowNegative={false}
                    />
                  }
                  defaultValue={pos.deposit}
                />
                {errors.deposit && errors.deposit.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Deposit")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Tag")}</label>{" "}
                <Tooltip text={translator("POS-Tag-Msg")} />
                <input
                  disabled={true}
                  type="text"
                  className="form-control"
                  ref={
                    pos.tag !== null
                      ? register({
                          required: true,
                          pattern: posTag,
                          validate: () =>
                            document.getElementsByName("tag")[0].value !==
                            pos.tag
                              ? validationService.validatePosTag(
                                  document.getElementsByName("tag")[0].value,
                                  Number(pos.storeId),
                                  Number(pos.tenantId)
                                )
                              : true,
                        })
                      : register({
                          pattern: posTag,
                          validate: () =>
                            document.getElementsByName("tag")[0].value !==
                            pos.tag
                              ? validationService.validatePosTag(
                                  document.getElementsByName("tag")[0].value,
                                  Number(pos.storeId),
                                  Number(pos.tenantId)
                                )
                              : true,
                        })
                  }
                  name="tag"
                  defaultValue={pos.tag}
                />
                {errors.tag && (
                  <>
                    {errors.tag.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                    {errors.tag && errors.tag.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-POSTagInUse")}
                      </p>
                    )}
                    {errors.tag.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PosTag")}
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Description")}</label>{" "}
                <Tooltip text={translator("POS-Description-Msg")} />
                <textarea
                  id="textArea"
                  rows="5"
                  className="form-control"
                  name="description"
                  ref={register({ maxLength: 250 })}
                  defaultValue={pos.description}
                />
                {errors.description &&
                  errors.description.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
              </div>

              <div className="form-group">
                <label>{translator("POS-New_EditPOS-DocumentNumber")}</label>{" "}
                <Tooltip text={translator("POS-DocumentNumber-Msg")} />
                <input
                  type="number"
                  className="form-control"
                  disabled={selectedPosId}
                  ref={register({
                    required: true,
                    max: 999999,
                    pattern: numbersOnly,
                  })}
                  name="documentNumber"
                  defaultValue={pos.documentNumber}
                />
                {errors.documentNumber &&
                  errors.documentNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {errors.documentNumber &&
                  errors.documentNumber.type === "max" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength6")}
                    </p>
                  )}
                {errors.documentNumber &&
                  errors.documentNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumberOnly")}
                    </p>
                  )}
              </div>
            </fieldset>
          </div>

          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("POS-New_EditPOS-OtherData")}
              </legend>
              <div className="form-group">
                <label>
                  {translator("POS-New_EditPOS-SubscriptionValidFrom")}
                </label>{" "}
                <Tooltip text={translator("POS-FromDate-Msg")} />
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="subscriptionValidFrom"
                    showYearDropdown={true}
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    defaultValue={
                      pos.subscriptionValidFrom !== null
                        ? new Date(pos.subscriptionValidFrom)
                        : ""
                    }
                    onChange={function ([selected]) {
                      setPos({ ...pos, subscriptionValidFrom: selected });
                      return selected;
                    }}
                    // maxDate={
                    //   pos.subscriptionValidTo !== null
                    //     ? new Date(pos.subscriptionValidTo)
                    //     : ""
                    // }
                  />
                </div>
                {errors.subscriptionValidFrom &&
                  errors.subscriptionValidFrom.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>

              {/* <div className="form-group">
                <label>
                  {translator("POS-New_EditPOS-SubscriptionValidTo")}
                </label>{" "}
                <Tooltip text={translator("POS-ToDate-Msg")} />
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="subscriptionValidTo"
                    showYearDropdown={true}
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    defaultValue={
                      pos.subscriptionValidTo !== null
                        ? new Date(pos.subscriptionValidTo)
                        : ""
                    }
                    onChange={function ([selected]) {
                      setPos({ ...pos, subscriptionValidTo: selected });
                      return selected;
                    }}
                    minDate={new Date(pos.subscriptionValidFrom)}
                  />
                </div>
                {errors.subscriptionValidTo &&
                  errors.subscriptionValidTo.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div> */}
              <div className="form-group">
            <label>{translator("Pos-Create-Mode")}</label>{" "}
            <Tooltip text={translator("Pos-Mode-Msg")} />
            <select
              name="modeId"
              ref={register({ required: true })}
              className="form-control"
            >
              <option value="" selected>
                {translator("Select-Mode")}
              </option>
              <option key={1} value={1} selected={pos.modeId == 1}>
                Standard mode
              </option>
              <option key={2} value={2} selected={pos.modeId == 2}>
                Easy mode
              </option>
            </select>
            {errors.roleId && errors.roleId.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
          <div className="form-group">
            <label>Payment App</label>
            <select
              name="paymentAppId"
              ref={register()}
              className="form-control"
              defaultValue={pos.paymentAppId || ""}
            >
              <option value="">-</option>
              <option value={1} selected={pos.paymentAppId == 1}>Combis</option>
              <option value={2} selected={pos.paymentAppId == 2}>Monri</option>
              {/* <option value={3} selected={pos.paymentAppId == 3}>Worldline</option> */}
            </select>
          </div>
          {Number(watchedPaymentAppId) === 2 && (
            <div className="form-group">
              <label>{translator("POS-New_EditPOS-TerminalName")}</label>
              <input
                type="text"
                className="form-control"
                ref={register({ required: true, maxLength: 100 })}
                name="terminalName"
                defaultValue={pos.terminalName}
              />
              {errors.terminalName &&
                errors.terminalName.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              {errors.terminalName &&
                errors.terminalName.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength100")}
                  </p>
                )}
            </div>
          )}
          <div className="form-group">
            <label>POS Type</label>
            <select
              name="posTypeId"
              ref={register()}
              className="form-control"
              defaultValue={pos.posTypeId || ""}
            >
              <option value="">-</option>
              <option value={1} selected={pos.posTypeId == 1}>Pax</option>
              <option value={2} selected={pos.posTypeId == 2}>SoftPos</option>
            </select>
          </div>
              <div className="row">
                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="workingMode"
                      ref={register}
                      disabled={
                        [master, admin, support].includes(Number(roleId))
                          ? false
                          : true
                      }
                      defaultChecked={
                        pos.tenantId !== "" ? pos.workingMode : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("PosDetail-WorkingMode")}</span>{" "}
                  <Tooltip text={translator("POS-WorkingMode-Msg")} />
                </div>
                {!selectedPosId && (
                  <div className="form-group col-12">
                    <label className="labelCont">
                      <input
                        type="checkbox"
                        name="workingMode"
                        ref={register}
                        defaultChecked={
                          pos.tenantId !== "" ? pos.workingMode : false
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span>
                      {translator("POS-New_EditPOS-Checkbox-WorkingMode")}
                    </span>{" "}
                    <Tooltip text={translator("POS-WorkingMode-Msg")} />
                  </div>
                )}

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="closeArticleSearch"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.closeArticleSearch : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-CloseAricleSearch")}
                  </span>{" "}
                  <Tooltip text={translator("POS-CloseAricleSearch-Msg")} />
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="multiDraft"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.multiDraft : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-MultiDraft")}
                  </span>{" "}
                  <Tooltip text={translator("POS-MultiDraft-Msg")} />
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="cashDefault"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.cashDefault : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-CashDefault")}
                  </span>{" "}
                  <Tooltip text={translator("POS-CashDefault-Msg")} />
                </div>

              </div>
            </fieldset>
          </div>
          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>

        </form>
      )}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditPOS;
